import { arraySchema, objectSchema } from "vue-utils"
import { MarriageClaimSchema, type MarriageClaim } from "./MarriageClaim"

export interface MarriageSearchResults {
	MarriageClaims: MarriageClaim[]
	TotalItems: number
	PageNumber: number
}

export const MarriageSearchResultsSchema = objectSchema<MarriageSearchResults>({
	MarriageClaims: arraySchema(MarriageClaimSchema),
	TotalItems: Number,
	PageNumber: Number,
})
